module.exports = __webpack_public_path__ + "img/2.6e3219ce.png";